export default {
  TableHead: [
    [
      {
        displayName: 'banner.datatable.number',
      },
      {
        displayName: 'banner.datatable.discription',
      },
      {
        displayName: 'banner.datatable.image',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'message.datatable.status',
      },
      {
        displayName: 'banner.datatable.createdate',
      },
      {
        displayName: 'banner.datatable.edit',
      },
      {
        displayName: 'banner.datatable.delete',
      },
    ],
  ],
  initialModel() {
    return {
      imagePath: '',
      description: '',
      isActive: true,
    };
  },
};
